import { PageTemplate, HeaderTemplate } from "../styles";
import { Link } from "react-router-dom";

const ReturnPolicy = () => {
  return (
    <>
      <HeaderTemplate className="narrow">
        <div className="header flex-header">
          <div className="title">
            <h1>Return Policy</h1>
          </div>
        </div>
      </HeaderTemplate>
      <PageTemplate className="narrow policy">
        <div className="content-page">
          <p>
            You have 15 days after receiving your item to make a request to return your item for a refund or exchange for a different size.
            We accept returns only for clothing that has not been worn, washed, or altered. Items must be in new, original condition with
            all tags attached. For hygiene and quality reasons, any used or laundered items will not be eligible for return.
          </p>
          <h2>HOLIDAY RETURN EXTENSION</h2>
          <p>
            Items purchased as gifts between November 15 and December 24 are eligible for return or exchange until January 15 of the
            following year, provided they meet the standard return conditions above.
          </p>
          <h2>1 FREE RETURN / 1 EXCHANGE PER ORDER</h2>
          <p>
            We offer 1 free return per order. Additional returns from the same order are subject to a shipping fee. We also only allow one
            exchange per order. If you choose to return additional items after a return label has already been created for an order, you
            will only have the option to refund those additional items minus a shipping fee.
          </p>
          <h2>START A RETURN</h2>
          <p>To start a return, there are three options:</p>
          <ul>
            <li>
              while logged in, go to your account page located at{" "}
              <Link className="text-link" to="/account">
                greygullapparel.com/account
              </Link>
            </li>
            <li>
              for guest users, use the order lookup form located at{" "}
              <Link className="text-link" to="/order-lookup">
                greygullapparel.com/order-lookup
              </Link>
            </li>
            <li>
              or contact us at{" "}
              <a className="text-link" href="mailto:support@greygullapparel.com">
                support@greygullapparel.com
              </a>
            </li>
          </ul>
          <p>
            If your return is accepted, we'll send you a return shipping label via email, as well as instructions on how and where to send
            your package. Items sent back to us without first requesting a return will not be accepted.
          </p>
          <p>
            You can always contact us for any return questions at{" "}
            <a className="text-link" href="mailto:support@greygullapparel.com">
              support@greygullapparel.com
            </a>
            .
          </p>

          <h2>DAMAGES AND ISSUES</h2>
          <p>
            Please inspect your order upon receipt and contact us immediately if the item is defective, damaged, or if you receive the wrong
            item, so that we may evaluate the issue and make it right.
          </p>
          <h2>REFUNDS/EXCHANGES</h2>
          <p>
            We will notify you once we've received and inspected your return to let you know if the refund or exchange was approved or not.
            If approved, we will either refund your payment to the original payment method within 10 business days or we will send you the
            new size you requested for an exchange. Please remember it can take some time for your bank or credit card company to process
            and post the refund too.
          </p>
          <p>
            If more than 15 business days have passed since we've approved your return, please contact us at{" "}
            <a className="text-link" href="mailto:support@greygullapparel.com">
              support@greygullapparel.com
            </a>
            .
          </p>
        </div>
      </PageTemplate>
    </>
  );
};

export default ReturnPolicy;
